export default {
  create: {
    title: 'Add',
    subtitle: 'Games',
  },
  edit: {
    title: 'Edit',
    subtitle: 'Game',
    button: {
      add: 'New game',
    },
  },
  list: {
    title: 'Walls',
    subtitle: 'List',
    add: 'New game',
  },
  card: {
    title: 'Walls',
    actions: 'Actions',
  },
  table: {
    title: 'Active games',
    searchPlaceholder: 'Search...',
  },
  form: {
    name: {
      label: 'Name:',
      placeholder: 'E.g.: Walls Level 1',
      invalid: 'Name is required',
    },
    showAnswer: {
      label: 'Show answer',
    },
    colored: {
      label: 'Colored',
    },
    columns: {
      label: 'Columns:',
    },
    rows: {
      label: 'Rows:',
    },
    level: {
      label: 'Level:',
      placeholder: 'Select the level...',
      invalid: 'Level is required',
      tooltip:
        'The level affects how the game is generated, but you can change it freely without regenerating.',
    },
  },
  button: {
    generate: 'Generate game',
  },
  sidebar: {
    exportHint: 'You need to save before exporting.',
    defaultFileName: 'walls',
  },
  alert: {
    generated: 'Puzzle generated successfully!',
    bestPuzzle: 'Best puzzle: {junk} junk cell(s).',
    generateFailed: 'Generation error.',
    workerCritical: 'Internal worker error.',
    gameSaved: 'Game saved successfully!',
    workerErrors: {
      noValidPuzzle: 'Could not generate a valid puzzle.',
    },
  },
};
